import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components';

const SectionWrapper = styled.section`
  padding: 150px 0;
  background: linear-gradient(180deg, rgba(253, 245, 230, 0) 0%, rgba(253, 245, 230, 0.8) 100%);
  @media only screen and (max-width: 1366px) {
    padding: 150px 0;
  }
  @media only screen and (max-width: 667px) {
    padding: 45px 0;
  }
`;

export const ButtonGroup = styled.div`
  text-align: center;
  --switchHeight: 44px;
  --switchWidth: 56px;
  font-size: 16px;
  color: ${themeGet('colors.textColorAlt')};
  font-weight: 600;
  .button_groups_wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
  }
  .button_groups_outer_wrapper {
    grid-gap: 14px;
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
  }
  .switch_outer {
    width: var(--switchWidth);
    height: calc(var(--switchHeight) / 2);
    border-radius: 450px;
    border-width: 4px;
    border-style: solid;
    transition-duration: 0.3s;
    transition-property: background-color;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    background-color: ${themeGet('colors.headingColor')};
    border-color: ${themeGet('colors.headingColor')};
  }
  .switch_inner {
    width: calc(var(--switchHeight) / 2 - 8px);
    height: calc(var(--switchHeight) / 2 - 8px);
    border-radius: 50%;
    pointer-events: none;
    top: 0px;
    left: 0px;
    position: absolute;
    background-color: ${themeGet('colors.secondary')};
    transition-timing-function: cubic-bezier(1,0,0,1);
    transition-duration: 0.3s;
    transition-property: left,background-color;
  }
  .promotion_alert_box {
    order: 3;
    background-color: ${themeGet('colors.cream')};
    color: ${themeGet('colors.secondaryDark')};
    border: 1px solid ${themeGet('colors.secondary')};
    border-radius: 999px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 700;
  }
  .switch_button {
    cursor: pointer;
    position: relative;
    padding-right: 17px;
    input[type="radio"] {
      opacity: 0;
      // display: none;
      position: absolute;
      left: calc(100% - 2px);
      z-index: 1;
      height: 100%;
      top: -7px;
      width: calc(var(--switchWidth) / 2);
      height: calc(var(--switchHeight) / 2);
      margin: 0;
      padding: 0;
      border: 0;
      cursor: pointer;
    }
    + .switch_button {
      padding-right: 0;
      padding-left: 17px;
      input[type="radio"] {
        left: auto;
        right: calc(100% - 2px);
      }
      order: 2;
    }
    &.checked {
      span {
        color: ${themeGet('colors.headingColor')};
      }
      + .switch_outer {
        .switch_inner {
          left: calc(var(--switchWidth) - var(--switchHeight) / 2);
        }
      }
    }
    &:not(.checked) span {
      opacity: 0.6;
    }
  }
`;

export const PricingArea = styled.div`
  max-width: 1170px;
  width: 100%;
  margin: 0 auto;
  padding-top: 90px;
  @media only screen and (max-width: 667px) {
    width: 100%;
    padding-top: 44px;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  grid-gap: 40px;
  @media only screen and (max-width: 1366px) {
    grid-gap: 30px;
  }
  @media only screen and (max-width: 991px) {
    grid-gap: 20px;
  }
  @media only screen and (max-width: 667px) {
    flex-direction: column;
    gap: 18px;
  }
  @media only screen and (max-width: 480px) {
    grid-gap: 10px;
  }
`;

export const PricingCard = styled.div`
  width: calc(100% / 2);
  max-width: 500px;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  border: 1px solid ${themeGet('colors.borderColor')};
  box-shadow: ${themeGet('colors.cardShadow')};
  background-color: ${themeGet('colors.white')};
  position: relative;
  overflow: hidden;

  ${({ highlighted }) => highlighted && css`
    border: 2px solid ${themeGet('colors.secondary')};
  `}

  @media only screen and (max-width: 991px) {
    width: calc(100% / 2);
  }
  @media only screen and (max-width: 667px) {
    width: 100%;
    max-width: none;
  }
  @media only screen and (max-width: 480px) {
    width: 100%;
  }

  .card-ribbon {
    display: inline-flex;
    align-items: center;
    margin: 0 auto 14px;
    padding: 5px 12px;
    background: ${themeGet('colors.secondary')};
    color: ${themeGet('colors.headingColor')};
    border-radius: 999px;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.03em;
    text-transform: uppercase;
  }

  .card-header {
    text-align: center;
    padding: 32px 32px 28px;
    @media only screen and (max-width: 480px) {
      padding: 28px 20px 20px;
    }
    h3 {
      color: ${themeGet('colors.headingColor')};
      letter-spacing: -0.3px;
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 18px;
    }
    p {
      letter-spacing: -0.2px;
      color: ${themeGet('colors.textColorAlt')};
      font-size: 16px;
      margin-top: 8px;
      margin-bottom: 0;
    }
    .price {
      color: ${themeGet('colors.headingColor')};
      font-weight: 800;
      display: flex;
      align-items: baseline;
      justify-content: center;
      line-height: 1;
      letter-spacing: -0.02em;

      &.price--number {
        font-size: 56px;
        @media (max-width: 480px) {
          font-size: 44px;
        }
        .symbol {
          font-size: 26px;
          font-weight: 700;
          margin-right: 4px;
        }
        .state {
          font-size: 18px;
          font-weight: 600;
          color: ${themeGet('colors.textColorAlt')};
          margin-left: 4px;
        }
      }

      &.price--text {
        font-size: 28px;
      }
    }
  }

  .card-body {
    flex: 1;
    padding: 0 32px 32px;
    @media only screen and (max-width: 480px) {
      padding: 0 20px 24px;
    }
    .feature-list {
      li {
        display: flex;
        align-items: flex-start;
        color: ${themeGet('colors.headingColor')};
        font-weight: 500;
        font-size: 15px;
        line-height: 1.5;
        letter-spacing: -0.1px;
        &:not(:last-child) {
          margin-bottom: 15px;
        }
        svg {
          flex: 0 0 auto;
          color: ${themeGet('colors.secondaryDark')};
          margin-right: 10px;
          margin-top: 2px;
          width: 18px;
          height: 18px;
        }
      }
    }
  }

  .card-footer {
    padding: 0 32px 32px;
    @media only screen and (max-width: 480px) {
      padding: 0 20px 24px;
    }
    .card_button {
      text-align: center;
      background-color: ${themeGet('colors.primary', '#1A1A1A')};
      display: block;
      color: ${themeGet('colors.white', '#FFF')};
      font-weight: 700;
      font-size: 16px;
      border-radius: 999px;
      padding: 16px;
      transition: background-color .25s ease;

      ${({ highlighted }) => highlighted && css`
        background-color: ${themeGet('colors.secondary')};
        color: ${themeGet('colors.headingColor')};
      `}

      &:hover {
        background-color: ${themeGet('colors.primaryHover', '#000000')};
        color: ${themeGet('colors.white')};
      }
    }
  }
`;

export const SectionHeader = styled.header`
  text-align: center;
  max-width: 440px;
  margin: 0 auto;
  margin-bottom: 34px;
  h2 {
    font-weight: 800;
    line-height: 36px;
    letter-spacing: -0.5px;
    @media (min-width: 1024px) {
      font-size: 26px;
    }
    @media (max-width: 600px) {
      font-size: 24px;
    }
    @media (max-width: 520px) {
      font-size: 18px;
    }
  }
  p {
    opacity: 0.7;
    line-height: 2.125;
    margin-bottom: 0;
  }
`;

export default SectionWrapper;
